/**
 * Featured Product Total
 * トップページの featured-product セクションで、数量に応じて表示価格を
 * 「単価 × 数量」にライブ更新する。
 *
 * 注意: これは表示専用。カートに送信されるのは quantity のみで、
 * 実際の金額計算は Shopify サーバー側が variant.price を正として行う。
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    switch (fmt.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }
    return fmt.replace(placeholderRegex, value);
  }

  function init(container) {
    var sectionId = container.dataset.sectionId;
    var basePrice = parseInt(container.dataset.basePrice, 10);
    var moneyFormat = container.dataset.moneyFormat;
    var qtyInput = document.getElementById('Quantity-' + sectionId);
    if (!qtyInput || isNaN(basePrice)) return;

    // 更新対象: price スニペットが描画する .price-item--regular / --sale
    var priceTargets = container.querySelectorAll(
      '.price-item--regular, .price-item--sale'
    );
    if (priceTargets.length === 0) return;

    // 元の単価表示を保持（数量 1 のときに戻すため）
    var originals = [];
    priceTargets.forEach(function (el) {
      originals.push(el.innerHTML);
    });

    function update() {
      var qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      if (qty === 1) {
        priceTargets.forEach(function (el, i) {
          el.innerHTML = originals[i];
        });
        return;
      }
      var total = basePrice * qty;
      var formatted = formatMoney(total, moneyFormat);
      priceTargets.forEach(function (el) {
        el.textContent = formatted;
      });
    }

    qtyInput.addEventListener('change', update);
    qtyInput.addEventListener('input', update);

    // バリアント変更で base price を更新
    // Dawn 系の PubSub (PUB_SUB_EVENTS.variantChange = 'variant-change') を購読
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (event) {
        var data = event && event.data;
        if (!data || data.sectionId !== sectionId) return;
        var variant = data.variant;
        if (!variant || typeof variant.price !== 'number') return;
        basePrice = variant.price;
        container.dataset.basePrice = String(variant.price);
        // Shopify が price ブロックの innerHTML を差し替えた直後に
        // 単価表示を取り直して、現在の数量で再計算
        setTimeout(function () {
          priceTargets = container.querySelectorAll(
            '.price-item--regular, .price-item--sale'
          );
          originals = [];
          priceTargets.forEach(function (el) {
            originals.push(el.innerHTML);
          });
          update();
        }, 0);
      });
    }
  }

  function boot() {
    document
      .querySelectorAll('[data-featured-product-total]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
